<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="stroke"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs v-if="gradient">
      <linearGradient
        :id="gradientId"
        gradientUnits="userSpaceOnUse"
        x1="4.46"
        y1="21.33"
        x2="19.54"
        y2="2.67"
      >
        <stop offset="17.49%" stop-color="var(--t-comment-ai-1, #ff3300)" />
        <stop offset="47.04%" stop-color="var(--t-comment-ai-2, #e5886d)" />
        <stop offset="64.23%" stop-color="var(--t-comment-ai-3, #8ed9e1)" />
      </linearGradient>
    </defs>
    <path
      d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"
    />
    <path d="M20 2v4" />
    <path d="M22 4h-4" />
    <circle cx="4" cy="20" r="2" />
  </svg>
</template>

<script>
export default {
  name: 'SparklesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    fill: {
      type: String,
      default: '#8A8D93'
    },
    gradient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gradientId() {
      return `t-comment-ai-gradient-${this._uid}`;
    },
    stroke() {
      return this.gradient ? `url(#${this.gradientId})` : this.fill;
    }
  }
};
</script>
